// extracted by mini-css-extract-plugin
module.exports = {"featured-story":"featured-story__qiaDG"};